import { render, staticRenderFns } from "./TextAvaliationItemStrategy.vue?vue&type=template&id=4f665248"
import script from "./TextAvaliationItemStrategy.vue?vue&type=script&lang=js"
export * from "./TextAvaliationItemStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports